import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import { store } from "../../../reducers";
import { setProxies, setProxyGroups } from "../../../reducers/option/actions";

// GET authorized/admin/app-init → {data: {nodes: {id: name}, device_types: {id: code},
// device_statuses: {status: label}, script_execute_statuses: {…}}}.
// Фронт использует nodes/device_types/device_statuses для state.option;
// грузятся один раз в AppInit после логина.
export default class ApiAppInit extends ApiModelWithAuth {
    pathDef = 'authorized/admin/app-init';
    formatterItem = null; // ответ — объект словарей, не запись

    // Ответ не список: без пагинации и без массива — своя фабрика вместо базовой.
    static Index() {
        const api = new this();
        api.__type = 'index';
        return api;
    }

    // Перечитать только справочник прокси. AppInit грузит справочники один раз за загрузку
    // страницы, а прокси заводят и выключают в разделе «Прокси» прямо по ходу работы —
    // без этого в выборе прокси устройству их не было бы до F5.
    static async ReloadProxies() {
        const data = await this.Index().getResponse();
        if (data && 'proxies' in data) store.dispatch(setProxies(data.proxies));
    }

    // Перечитать справочники прокси и групп прокси — после правки групп (создание, переименование,
    // срок, удаление) и состава: подпись группы и подписи прокси меняются по ходу работы.
    static async ReloadProxyGroups() {
        const data = await this.Index().getResponse();
        if (!data) return;
        if ('proxy_groups' in data) store.dispatch(setProxyGroups(data.proxy_groups));
        if ('proxies' in data) store.dispatch(setProxies(data.proxies));
    }
}
